import * as Home from './HomeReducer';
import * as Membership from './EndUser/MembershipReducer';
import * as Common from './CommonReducer';
import * as Billing from './EndUser/BillingReducer';
import * as Store from './EndUser/StoreReducer';
import * as SignupWizard from './SignupWizardReducer';
import * as User from './Admin/ManageUserReducer';
import * as auth from './Auth/AuthReducer';
import * as changePassword from './Auth/ChangePasswordReducers';
import * as District from './Admin/ManageDistrictReducer';
import * as Region from './Admin/ManageRegionReducer';
import * as createAccount from './CreateAccountReducer';
import * as accountDetails from './EndUser/AccountDetailsReducer';
import * as organization from './EndUser/OrganizationReducer';
import * as preference from './EndUser/AccountPreferenceReducer';
import * as Committee from './Admin/ManageCommitteeReducer';
import * as Position from './Admin/ManagePositionReducer';
import * as PositionGroup from './Admin/ManagePositionGroupReducer';
import * as Events from './Admin/ManageEventReducer';
import * as Colors from './Admin/ManageColorReducer';
import * as Sizes from './Admin/ManageSizeReducer';
import * as Products from './Admin/ManageProductReducer';
import * as ProductTypes from './Admin/ManageProductTypeReducer';
import * as MemberInvitation from './EndUser/MemberInvitationReducer';
import * as Subscription from './EndUser/SubscriptionReducer';
import * as AdminSubscription from './Admin/ManageSubscriptionReducer';
import * as SubscriptionStatus from './Admin/ManageSubscriptionStatusReducer'
import * as SubscriptionType from './Admin/ManageSubscriptionTypeReducer'
import * as Invoices from './Admin/ManageInvoiceReducer';
import * as AdminMembership from './Admin/ManageMembershipReducer';
import * as AdminOrganization from './Admin/ManageOrganizationReducer';
import * as PurchaseAndRenewals from './Admin/ManagePurchaseAndRenewalsReducer';
import * as Orders from './Admin/ManageOrderReducer';
import * as AdminMembershipUser from './Admin/ManageMembershipUserReducer';
import * as CommitteeMember from './Admin/ManageCommitteeMemberReducer';
import * as MembershipsForBoard from './EndUser/MembershipsForBoardReducer';

const reducers = {
	home: Home.reducer,
	membership: Membership.reducer,
	common: Common.reducer,
	billing: Billing.reducer,
	signupWizard: SignupWizard.reducer,
	user: User.reducer,
	authentication: auth.authentication,
	district: District.reducer,
	region: Region.reducer,
	changePassword: changePassword.changePassword,
	createAccount: createAccount.createAccount,
	accountDetails: accountDetails.accountDetails,
	organization: organization.reducer,
	preference: preference.preference,
	committee: Committee.reducer,
	position: Position.reducer,
	groupReducer: PositionGroup.reducer,
	event:Events.reducer,
	color:Colors.reducer,
	size:Sizes.reducer,
    product: Products.reducer,
	store: Store.reducer,
	productType:ProductTypes.reducer,
	memberInvitation: MemberInvitation.reducer,
	adminSubscription: AdminSubscription.reducer,
	subscriptionStatus: SubscriptionStatus.reducer,
	subscriptionType: SubscriptionType.reducer,
	invoice: Invoices.reducer,
	adminMembership:AdminMembership.reducer,
    subscription: Subscription.reducer,
	purchaseAndRenewals: PurchaseAndRenewals.reducer,
	order:Orders.reducer,
	membershipUser: AdminMembershipUser.reducer,
	organizationUser: AdminOrganization.reducer,
	committeeMember: CommitteeMember.reducer,
	membershipsForBoard: MembershipsForBoard.reducer,
};

export default reducers;
